/**
 * @version: 1.1.0
 * @author: John Bandy, john@concatsys.com
 * @company: Concat Systems, Inc.
 *
 * @description: convenience functions for Date objects, conversions, etc.
 *
 * @copyright 2020 Concat Systems, Inc.
 *
 * {@link https://github.com/ConcatSystems/ConcatJS}
 */


// imports
import { Pad } from "./Numbers.js";


//------------------------------------------------------------------------------
/**
 * Gets the time-related parts from a date object
 * @param  {Date}   date  date object
 * @return {Object}       contains hour, minutes, seconds, and milliseconds
 */
const TimeParts = ( date, usePadding = true ) => 
  {
    return { 
      h  : usePadding ? Pad( date.getHours() )           : date.getHours(),
      m  : usePadding ? Pad( date.getMinutes() )         : date.getMinutes(),
      s  : usePadding ? Pad( date.getSeconds() )         : date.getSeconds(),
      ms : usePadding ? Pad( date.getMilliseconds(), 3 ) : date.getMilliseconds()
    }
  };

//------------------------------------------------------------------------------
/**
 * Gets a timecode from a date objects
 * @param  {Date}    date  date object
 * @param  {Boolean} useMS does the time code need miliseconds?
 * @return {String}        the resulting timecode
 */
const Timecode = ( date, useMS = true ) =>
  {
    let { h, m, s, ms } = TimeParts( date, true );
    return( `${h}:${m}:${s}` + ( useMS ? `.${ms}` : "" ));
  };


export { TimeParts, Timecode };
